
import {Device} from '../../base/Device';
import NetWork from '../../base/NetWork';
/**
 * @author yeyuchao
 * @description Elab creator.
 */
const website = "https://dm.static.elab-plus.com/";
const screenWidth = window.screen.width;
const screenHeight = window.screen.height;
export default {
  data() {
    return {
      elabCreatorSpeak:[
        {speak:"“可不可以,开启一段旅程，无关其他，只为热爱?”",author:"蔡雪梅",backStory:"2015年，蔡雪梅深刻感知到地产行业的内忧外患，同时看到了地产外技术赋能下的新的商业环境，" +
                                                                                   "在传统地产公司无法大刀阔斧改革的情况下，" +
                                                                                   "毅然结束了 20 年的房地产高级职业经理人生涯，在上海创办了以技术和数据驱动的新型房地产开发互联网平台型公司，ELAB。"},
        {speak:"“探索必不可少”",author:"蔡雪梅",backStory:"现在，蔡雪梅正和她的团队，持续推动创新，通过技术，数据，产品赋能，改变传统开发模式，实现以客户需求为核心的未来人居创新产品预制开发，努力 让ELAB成为客户价值和客户利益的创造者，研究未来最领先的生活方式和美好体验，并从源头解决开发商痛点，推动行业可持续发展。"}
      ],
      deviceMobile:false
    };
  },
  mounted() {
  },
  created() {
    if(!window.loadComplete){
      this.$router.push('/');
      return
    }
    const device = new Device();
    if(device.phone){
      this.deviceMobile = true;
    }
  },
  methods:{
    closeElabCreatorPages(){
      this.$router.push('/elabIntroduce');
    },
  }
};



// WEBPACK FOOTER //
// ./src/pages/elabCreator/elabCreator.js